export interface Review {
  id: string;
  productId: string;
  author: string;
  avatar: string;
  rating: number;
  date: string;
  title: string;
  body: string;
  verified: boolean;
  helpful: number;
  tags?: string[];
}

export const reviews: Review[] = [
  {
    id: 'r001',
    productId: 'stormshield-pro-jacket',
    author: 'Marcus T.',
    avatar: 'https://public.readdy.ai/ai/img_res/505e539b0254810980a2215d2ce1a170.jpg',
    rating: 5,
    date: 'March 12, 2026',
    title: 'Absolutely bomb-proof in the worst conditions',
    body: 'Wore this on a 3-day alpine traverse in the Cascades. Constant rain, wind gusts up to 50mph — stayed completely dry the entire time. The pit-zip venting is a game changer for high-output climbs. The hood fits perfectly over my helmet and the packable feature is super convenient. Worth every single penny.',
    verified: true,
    helpful: 47,
    tags: ['Waterproof', 'Fit', 'Durability'],
  },
  {
    id: 'r002',
    productId: 'stormshield-pro-jacket',
    author: 'Sarah K.',
    avatar: 'https://readdy.ai/api/search-image?query=female%20trail%20runner%20portrait%20smiling%20outdoor%20nature%20background%2C%20active%20lifestyle%20photography%20natural%20light&width=80&height=80&seq=3002&orientation=squarish',
    rating: 5,
    date: 'February 28, 2026',
    title: 'Best jacket I\'ve ever owned — period',
    body: 'I\'ve tried a lot of shells over the years and this one beats them all. The 3-layer Gore-Tex is noticeably more breathable than my old jacket. Sizing runs true — I\'m 5\'7" and the medium fits perfectly with a mid-layer underneath. The seam taping is flawless, zero leaks anywhere.',
    verified: true,
    helpful: 31,
    tags: ['Breathability', 'Sizing', 'Value'],
  },
  {
    id: 'r003',
    productId: 'stormshield-pro-jacket',
    author: 'James P.',
    avatar: 'https://readdy.ai/api/search-image?query=male%20mountaineer%20portrait%20with%20climbing%20gear%20outdoors%2C%20adventure%20photography%20natural%20background&width=80&height=80&seq=3003&orientation=squarish',
    rating: 4,
    date: 'January 15, 2026',
    title: 'Great jacket, pockets could be better',
    body: 'Overall this is an excellent jacket. The waterproofing is top-notch and it packs down surprisingly small. My only gripe is the hand pockets are a bit shallow — hard to fit a full-size phone in them. That said, the chest pocket is great and the overall construction quality is outstanding.',
    verified: true,
    helpful: 18,
    tags: ['Waterproof', 'Packability'],
  },
  {
    id: 'r004',
    productId: 'stormshield-pro-jacket',
    author: 'Lisa W.',
    avatar: 'https://readdy.ai/api/search-image?query=female%20backpacker%20portrait%20smiling%20in%20forest%20setting%2C%20outdoor%20adventure%20lifestyle%20photography&width=80&height=80&seq=3004&orientation=squarish',
    rating: 5,
    date: 'December 3, 2025',
    title: 'Survived a full PCT section in this',
    body: 'Took this on an 8-day PCT section through the Sierra Nevada. Rain, sleet, and even some snow — this jacket handled everything. The DWR treatment is still holding up after multiple washes. Highly recommend pairing it with the Summit HydroPack for the ultimate trail setup.',
    verified: true,
    helpful: 62,
    tags: ['Durability', 'Waterproof', 'Versatility'],
  },
  {
    id: 'r005',
    productId: 'stormshield-pro-jacket',
    author: 'Chen R.',
    avatar: 'https://readdy.ai/api/search-image?query=male%20rock%20climber%20portrait%20with%20climbing%20equipment%2C%20athletic%20outdoor%20photography%20natural%20light&width=80&height=80&seq=3005&orientation=squarish',
    rating: 5,
    date: 'November 20, 2025',
    title: 'Perfect for climbing and alpine approaches',
    body: 'As a climber, I need a jacket that moves with me and doesn\'t restrict my range of motion. This one nails it. The articulated patterning is excellent and the helmet-compatible hood is a must-have feature. Wore it on a 5-pitch route in the rain and it performed flawlessly.',
    verified: false,
    helpful: 24,
    tags: ['Mobility', 'Fit', 'Hood'],
  },
  {
    id: 'r006',
    productId: 'alpine-trail-runner-x7',
    author: 'Amy D.',
    avatar: 'https://readdy.ai/api/search-image?query=female%20camper%20smiling%20at%20campsite%20with%20tent%20background%2C%20outdoor%20camping%20lifestyle%20photography%20warm%20light&width=80&height=80&seq=3006&orientation=squarish',
    rating: 5,
    date: 'March 5, 2026',
    title: 'Best trail shoes I\'ve ever run in',
    body: 'On my 4th pair of these now. The grip on wet rocks is unreal — I\'ve run in conditions where I\'d normally slip and these just hold. The wide toe box is perfect for long days when feet swell. Waterproofing holds up great even after 400+ miles.',
    verified: true,
    helpful: 89,
    tags: ['Grip', 'Durability', 'Comfort'],
  },
  {
    id: 'r007',
    productId: 'basemount-2p-tent',
    author: 'Marcus T.',
    avatar: 'https://readdy.ai/api/search-image?query=confident%20male%20hiker%20portrait%20with%20mountain%20background%2C%20outdoor%20lifestyle%20photography%2C%20warm%20natural%20light&width=80&height=80&seq=3001&orientation=squarish',
    rating: 5,
    date: 'February 10, 2026',
    title: 'Survived 60mph gusts in the Whites',
    body: 'Set this up in the White Mountains during a surprise storm with 60mph gusts. The tent held perfectly — not even a single pole flex that worried me. Setup is incredibly intuitive with the color-coded system. The dual vestibules are huge for storing wet gear.',
    verified: true,
    helpful: 41,
    tags: ['Wind Resistance', 'Setup', 'Space'],
  },
  {
    id: 'r008',
    productId: 'trailnavi-gps-watch',
    author: 'James P.',
    avatar: 'https://readdy.ai/api/search-image?query=male%20mountaineer%20portrait%20with%20climbing%20gear%20outdoors%2C%20adventure%20photography%20natural%20background&width=80&height=80&seq=3003&orientation=squarish',
    rating: 5,
    date: 'January 28, 2026',
    title: '21-day battery is absolutely real',
    body: 'I was skeptical about the battery claim but it\'s legit. Did a 12-day expedition with GPS tracking on the whole time and still had 40% battery left. The topo maps are incredibly detailed and the altimeter is spot-on. Best GPS watch on the market at this price point.',
    verified: true,
    helpful: 55,
    tags: ['Battery Life', 'GPS Accuracy', 'Maps'],
  },
  {
    id: 'r009',
    productId: 'summit-hydro-pack-25l',
    author: 'Sarah K.',
    avatar: 'https://readdy.ai/api/search-image?query=female%20trail%20runner%20portrait%20smiling%20outdoor%20nature%20background%2C%20active%20lifestyle%20photography%20natural%20light&width=80&height=80&seq=3002&orientation=squarish',
    rating: 4,
    date: 'March 1, 2026',
    title: 'Great pack for trail running and day hikes',
    body: 'The magnetic tube routing is genius — no more fumbling for the hose. Fits snugly even when running technical terrain. The only thing I\'d change is adding a front pocket for quick-access snacks. Otherwise this is my go-to for anything under 10 miles.',
    verified: true,
    helpful: 29,
    tags: ['Fit', 'Hydration System', 'Comfort'],
  },
  {
    id: 'r010',
    productId: 'tacticalpeak-45l',
    author: 'Lisa W.',
    avatar: 'https://readdy.ai/api/search-image?query=female%20backpacker%20portrait%20smiling%20in%20forest%20setting%2C%20outdoor%20adventure%20lifestyle%20photography&width=80&height=80&seq=3004&orientation=squarish',
    rating: 5,
    date: 'February 18, 2026',
    title: 'Handled my 8-day PCT section perfectly',
    body: 'Loaded this with 35lbs for an 8-day section and my back felt great every single day. The hip belt is incredibly comfortable and the adjustable torso fit my 18" torso perfectly. The rain cover is a must-have and I love that it\'s integrated. Fast shipping from Phoenix too!',
    verified: true,
    helpful: 38,
    tags: ['Comfort', 'Load Carry', 'Organization'],
  },
];
